<template>
  <div class="flex flex-wrap lg:flex-nowrap items-stretch justify-center items-start lg:-mx-5">

    <!--GOLD-->
    <div
        v-if="display.find(el => el === 'gold')"
        :class="{ 'border' : border }"
        class="relative flex flex-col justify-between w-full lg:w-1/3 bg-beige rounded shadow-2xl mt-4 py-6 px-3 lg:px-6 lg:mx-5 text-left lg:order-3">
      <div
          class="absolute right-0 top-10 bg-dark-blue text-white py-2 px-3 uppercase font-bold text-center">
        Recommandée
      </div>
      <div>
        <p class="font-bold text-xl capitalize">{{ $trans('app.gold') }}</p>
        <div class="flex items-baseline">
          <p class="text-medium-blue font-bold text-3xl uppercase">{{ packagePrice('gold') }} €</p>
          <p class="line-through ml-4 text-2xl font-bold text-red-500" v-if="this.package && this.package.name !== 'bronze'">
            {{ prices['gold'] / 100 }} €</p>
        </div>

        <hr class="border-dark-blue my-4">

        <bullet-point bullet-color="text-medium-blue" class="mt-3">{{
            $trans('app.packages.your-results')
          }}
        </bullet-point>
        <bullet-point bullet-color="text-medium-blue" class="mt-3">{{
            $trans('app.packages.action-plan-7')
          }}
        </bullet-point>
        <bullet-point bullet-color="text-medium-blue" class="mt-3">{{ $trans('app.packages.3-videos') }}</bullet-point>
        <bullet-point bullet-color="text-medium-blue" class="mt-3">{{ $trans('app.packages.5-videos') }}</bullet-point>
        <bullet-point bullet-color="text-medium-blue" class="mt-3 font-bold">{{
            $trans('app.packages.1-hour-coaching')
          }}
        </bullet-point>
      </div>

      <div class="flex flex-col items-center">
        <hr class="border-dark-blue my-4 w-full">

        <slot name="gold-package"></slot>
      </div>
    </div>

    <!--SILVER-->
    <div
        v-if="display.find(el => el === 'silver')"
        :class="{ 'border' : border }"
        class="relative flex flex-col justify-between w-full lg:w-1/3 bg-white border-medium-blue rounded py-6 px-3 lg:px-6 mt-4 lg:mx-5 lg:mt-16 text-left lg:order-2">
      <!--<div-->
      <!--    class="absolute right-0 top-10 bg-dark-blue text-white py-2 px-3 uppercase font-bold text-center">-->
      <!--    Recommandée-->
      <!--</div>-->
      <div>
        <p class="font-bold text-xl capitalize">{{ $trans('app.silver') }}</p>
        <div class="flex items-baseline">
          <p class="text-medium-blue font-bold text-3xl uppercase">{{ packagePrice('silver') }} €</p>
          <p class="line-through ml-4 text-2xl font-bold text-red-500" v-if="this.package && this.package.name !== 'bronze'">
            {{ prices['silver'] / 100 }} €</p>
        </div>

        <hr class="border-light-blue my-4">

        <bullet-point bullet-color="text-medium-blue" class="mt-3">{{
            $trans('app.packages.your-results')
          }}
        </bullet-point>
        <bullet-point bullet-color="text-medium-blue" class="mt-3">{{
            $trans('app.packages.action-plan-7')
          }}
        </bullet-point>
        <bullet-point bullet-color="text-medium-blue" class="mt-3">{{ $trans('app.packages.3-videos') }}</bullet-point>
        <bullet-point bullet-color="text-medium-blue" class="mt-3">{{ $trans('app.packages.5-videos') }}</bullet-point>
      </div>

      <div class="flex flex-col items-center">
        <hr class="border-light-blue my-4 w-full">

        <slot name="silver-package"></slot>
      </div>
    </div>

    <!--BRONZE-->
    <div
        v-if="!isUpgrade && display.find(el => el === 'bronze')"
        :class="{ 'border' : border }"
        class="flex flex-col justify-between w-full lg:w-1/3 bg-white border-medium-blue rounded py-6 px-3 lg:px-6 mt-4 lg:mx-5 lg:mt-16 text-left lg:order-1">
      <div>
        <p class="font-bold text-xl capitalize">Bronze</p>
        <p class="text-medium-blue font-bold text-3xl uppercase">{{ $trans('app.free') }}</p>

        <hr class="border-light-blue my-4">

        <bullet-point bullet-color="text-medium-blue" class="mt-3">{{
            $trans('app.packages.your-results')
          }}
        </bullet-point>
      </div>

      <div class="flex flex-col items-center">
        <hr class="border-light-blue my-4 w-full">

        <slot name="bronze-package"></slot>
      </div>
    </div>

  </div>
</template>
<script>
import BubbleButton from "@/Components/BubbleButton"
import BulletPoint from "@/Components/BulletPoint"

export default {
  name: 'pricing-cards',
  components: {BubbleButton, BulletPoint},
  props: {
    border: {
      type: Boolean,
      default: false
    },
    display: {
      type: Array,
      default: ['bronze', 'silver', 'gold', 'diamond']
    },
    prices: {},
    package: {
      default: null
    },
    isUpgrade: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    packagesPrices() {
      if (!this.package || this.package.name === 'bronze') {
        return {
          'silver': this.prices['silver'] / 100,
          'gold': this.prices['gold'] / 100,
          //'diamond': this.prices['diamond'] / 100,
        }
      } else {
        return {
          'silver': (this.prices['silver'] - this.prices[this.package.name]) / 100,
          'gold': (this.prices['gold'] - this.prices[this.package.name]) / 100,
        }
      }
    }
  },
  methods: {
    packagePrice(formula) {
      if (!this.package || this.package.name === 'bronze') {
        return this.prices[formula] / 100
      } else {
        return (this.prices[formula] - this.prices[this.package.name]) / 100
      }
    }
  }

}
</script>
